// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"36":"MarketTrendsPage.loadable","161":"PriceMyRentalResultsPage.loadable"}[chunkId] || chunkId) + "." + {"36":"c1fa5873","161":"447c11b5","848":"abc7678a","914":"8b0e96cf"}[chunkId] + ".js";
};